(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.promutuel_animations = {
    attach: function attach(context) {

      window.addEventListener('DOMContentLoaded', () => {
        document.body.classList.add('animated');
      });
    }
  };
})(jQuery, Drupal);
